import { createApi, createStore } from 'effector'

export namespace $pagerBackground {
  export const store = createStore<string>(null!)

  export const api = createApi(store, {
    set: (_, value: string) => value
  })
}
